import { Link, NavLink } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Building2, Menu, X } from "lucide-react";
import { useState } from "react";
import BrandLogo from "@/components/site/BrandLogo";
import { APP_REGISTER_URL, APP_LINK_PROPS, track } from "@/lib/config";
import { ConnexionMenu, ConnexionListeMobile } from "@/components/site/EspacesConnexion";


export default function Navbar() {
    const [open, setOpen] = useState(false);

    const linkBase = "text-sm font-medium text-slate-600 hover:text-primary-700 transition-colors";
    const linkActive = "text-primary-700";

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 w-full border-b border-slate-200/70 bg-white/90 md:bg-white/75 md:backdrop-blur-xl"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 items-center justify-between">
                    <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
                        <BrandLogo
                            variant="color"
                            className="h-9 w-auto md:h-10"
                            fetchPriority="high"
                            fallback={
                                <>
                                    <div className="h-9 w-9 rounded-xl bg-primary-700 grid place-items-center text-white">
                                        <Building2 className="h-5 w-5" strokeWidth={1.75} />
                                    </div>
                                    <span className="font-heading text-xl font-semibold tracking-tight text-slate-900">
                                        TyCopro
                                    </span>
                                </>
                            }
                        />
                    </Link>

                    <nav className="hidden md:flex items-center gap-6">
                        <a href="/#fonctionnalites" data-testid="nav-features" className={linkBase}>
                            Fonctionnalités
                        </a>
                        <a href="/#comparatif" data-testid="nav-comparison" className={`${linkBase} hidden lg:inline-block`}>
                            Comparatif
                        </a>
                        <a href="/#tarifs" data-testid="nav-pricing" className={linkBase}>
                            Tarifs
                        </a>
                        <a href="/#devis" data-testid="nav-devis" className={`${linkBase} hidden lg:inline-block`}>
                            Devis
                        </a>
                        <NavLink
                            to="/outils"
                            data-testid="nav-tools"
                            className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`}
                        >
                            Outils gratuits
                        </NavLink>
                        <NavLink
                            to="/aide"
                            data-testid="nav-help"
                            className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`}
                        >
                            Guides & modèles
                        </NavLink>
                        <a href="/#faq" data-testid="nav-faq" className={`${linkBase} hidden lg:inline-block`}>
                            FAQ
                        </a>
                    </nav>

                    <div className="hidden md:flex items-center gap-3">
                        {/* Deux espaces, deux portes : TyCopro (syndics, copropriétaires) et
                            TyCopro Manager (opérateurs, collectivités). */}
                        <ConnexionMenu />
                        <Button
                            asChild
                            data-testid="nav-cta-trial"
                            className="bg-primary-700 hover:bg-primary-600 text-white rounded-xl px-5"
                        >
                            <a
                                href={APP_REGISTER_URL}
                                {...APP_LINK_PROPS}
                                onClick={() => track("cta_clicked", { cta: "navbar" })}
                            >
                                Démarrer
                            </a>
                        </Button>
                    </div>

                    <button
                        type="button"
                        data-testid="nav-mobile-toggle"
                        className="md:hidden p-2 text-slate-700"
                        onClick={() => setOpen((v) => !v)}
                        aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
                        aria-expanded={open}
                        aria-controls="menu-mobile"
                    >
                        {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                    </button>
                </div>
            </div>

            {open && (
                <div id="menu-mobile" className="md:hidden border-t border-slate-200 bg-white max-h-[calc(100dvh-4rem)] overflow-y-auto">
                    <div className="px-4 py-4 flex flex-col gap-3">
                        <a onClick={() => setOpen(false)} href="/#fonctionnalites" className={linkBase}>
                            Fonctionnalités
                        </a>
                        <a onClick={() => setOpen(false)} href="/#comparatif" className={linkBase}>
                            Comparatif
                        </a>
                        <a onClick={() => setOpen(false)} href="/#tarifs" className={linkBase}>
                            Tarifs
                        </a>
                        <a onClick={() => setOpen(false)} href="/#devis" className={linkBase}>
                            Devis
                        </a>
                        <Link onClick={() => setOpen(false)} to="/outils" className={linkBase}>
                            Outils gratuits
                        </Link>
                        <Link onClick={() => setOpen(false)} to="/aide" className={linkBase}>
                            Guides & modèles
                        </Link>
                        <a onClick={() => setOpen(false)} href="/#faq" className={linkBase}>
                            FAQ
                        </a>
                        <div className="mt-2 border-t border-slate-100 pt-4">
                            <ConnexionListeMobile onNavigate={() => setOpen(false)} />
                        </div>
                        <Button
                            asChild
                            className="bg-primary-700 hover:bg-primary-600 text-white rounded-xl"
                        >
                            <a
                                href={APP_REGISTER_URL}
                                {...APP_LINK_PROPS}
                                onClick={() => {
                                    setOpen(false);
                                    track("cta_clicked", { cta: "navbar_mobile" });
                                }}
                            >
                                Démarrer
                            </a>
                        </Button>
                    </div>
                </div>
            )}
        </header>
    );
}
